var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.80982 7.1647C4.71161 7.26266 4.6337 7.37904 4.58053 7.50716C4.52737 7.63528 4.5 7.77264 4.5 7.91135C4.5 8.05007 4.52737 8.18742 4.58053 8.31554C4.6337 8.44366 4.71161 8.56004 4.80982 8.658L11.9051 15.7533C11.9831 15.8315 12.0759 15.8935 12.1779 15.9359C12.28 15.9782 12.3894 16 12.4999 16C12.6104 16 12.7198 15.9782 12.8219 15.9359C12.9239 15.8935 13.0166 15.8315 13.0947 15.7533L20.1899 8.658C20.6033 8.2446 20.6033 7.5781 20.1899 7.1647C19.7766 6.7513 19.1101 6.7513 18.6967 7.1647L12.5041 13.3572L6.30312 7.15627C5.88972 6.7513 5.22322 6.7513 4.80982 7.1647Z",
    fill: "#306A57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron_down.529243d6d96ffab7cf2d8839909e9dce.svg";
export { ForwardRef as ReactComponent };